<template lang="pug">

  .sosWindow(v-if="show" style="z-index: 202;")

    .sosWindow__inner(style="transform-origin: center center; width: 20%")

      .dialogHeader

        .dialogHeaderTitle
          | Redefinição de senha

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeRecoveryWindow")

      form(action="" @submit.prevent="onSubmit" login)

        .dialogBody

          .dialogBodyContent

            p.cardWelcomeTitle.text-left.mt-0.mb-4
              | Receba instruções no seu e-mail para gerar uma nova senha:

            sos-login-field(ref="recoveryEmail" name="email" type="email" v-model="recoveryEmail.value" :maxLength="128" placeholder="E-mail" :showSuccess="recoveryEmail.success" :showError="recoveryEmail.error" :fieldErrors="recoveryEmail.errorMessages" :disabled="loading" :showButton="String(recoveryEmail.value).length > 0" @buttonClick="clearRecoveryEmail" buttonIcon="mdi-close" :buttonDisabled="loading")

        .dialogFooter.text-right
          sos-button(type="submit" size="medium" buttonLabel="Enviar" buttonIcon="" buttonIconSize="16" :disabled="loading" :loading="loading" full)

</template>

<script>

  //
  //
  //

  import { apiRecoveryPassword } from '@/services/session'

  import { isValidEmail } from '@/mixins/regex.mixin'
  import fieldManagement from '@/constants/loginFieldObject'

  import SosButton from '@/components/SosButton'
  import SosLoginField from '@/components/SosLoginField'

  //
  //
  //
  // Component
  //
  //
  //

  export default {
    name: 'PasswordRecoveryModal',

    components: {
      'sos-button': SosButton,
      'sos-login-field': SosLoginField,
    },

    data: () => ({
      show: false,
      loading: false,
      recoveryEmail: { ...fieldManagement, value: '' },
    }),

    methods: {
      //
      //
      //

      open (email) {
        this.recoveryEmail.value = email
        this.show = true
      },

      closeRecoveryWindow () {
        if (this.loading) return false

        this.loading = false
        this.recoveryEmail = { ...fieldManagement, value: '' }

        this.show = false
      },

      clearRecoveryEmail () {
        this.recoveryEmail.value = ''
      },

      //
      //
      //
      // RECOVERY FORM
      //
      //
      //

      async onSubmit ()
      {
        // CLEAN FIELDS STATUSES

        this.recoveryEmail.setError('')

        // VALIDATE

        const recoveryEmail = String(this.recoveryEmail.value).trim()

        if (!isValidEmail(recoveryEmail))
        {
          this.recoveryEmail.setError('Informe um e-mail válido.')

          this.$nextTick(() => { this.$refs.recoveryEmail.triggerBounce() })
          this.$nextTick(() => { this.$refs.recoveryEmail.onFocus() })

          return false
        }

        // RUN

        this.loading = true

        const response = await apiRecoveryPassword(recoveryEmail)

        this.loading = false

        // [24/01/25] console.log('::: RECOVERY PASSWORD:', response)

        if (response.code === 0)
        {
          const requestErrorCode = response.message.code || ''

          if (requestErrorCode === 'auth/user-not-found') {
            this.recoveryEmail.setError('O e-mail não foi encontrado.')
          } else {
            this.recoveryEmail.setError('Não foi possível processar o pedido. Por favor, tente novamente ou fale com o nosso suporte.')
          }

          this.$nextTick(() => { this.$refs.recoveryEmail.triggerBounce() })
          this.$nextTick(() => { this.$refs.recoveryEmail.onFocus() })
        }
        else
        {
          this.recoveryEmail.setSuccess('Te enviamos um e-mail com as próximas instruções.')
        }
      },
    },
  }

</script>
